<template>
  <div class="attendance-index">
    <div class="title">
      <span>考勤列表</span>
      <!-- <mu-button class="add-btn" color="purple" @click="addOpen = true">
        <mu-icon value="add" :size="20"></mu-icon>
        新增考勤列表
      </mu-button> -->
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <mu-form-item prop="search" label="搜索" label-position="left">
        <mu-text-field
          v-model="form.keyword"
          help-text="请输入搜索内容"
        ></mu-text-field>
      </mu-form-item>
      <mu-form-item>
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          搜索
        </mu-button>
      </mu-form-item>
    </mu-form>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>{{ scope.row.user.realName }}</td>
          <td :class="scope.row.delaySecond > 0 ? 'red' : ''">
            {{ moment(scope.row.startTime).format('MM-DD HH:mm') }}
          </td>
          <td :class="scope.row.advanceSecond > 0 ? 'red' : ''">
            {{
              scope.row.endTime
                ? moment(scope.row.endTime).format('MM-DD HH:mm')
                : ''
            }}
          </td>
          <td>{{ scope.row.remark }}</td>
          <!-- <td>
            <mu-button color="info" @click="edit(scope.row)">
              <mu-icon left value="edit" :size="20"></mu-icon>
              编辑
            </mu-button>
            <mu-button color="secondary" @click="deleteOne(scope.row)">
              <mu-icon left value="delete" :size="20"></mu-icon>
              删除
            </mu-button>
          </td> -->
        </template>
      </mu-data-table>
    </mu-paper>
    <div class="page">
      <div class="info">共{{ total }}条记录</div>
      <mu-pagination
        raised
        :total="total"
        :current.sync="form.page"
        :page-size="15"
        @change="getAll"
      ></mu-pagination>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()"></Create>
    <Update :open.sync="editOpen" :form="editForm" @finish="getAll()"></Update>
  </div>
</template>

<script>
import Create from './create'
import Update from './update'
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
export default {
  components: { Create, Update },
  data() {
    return {
      loading: false,
      addOpen: false,
      editOpen: false,
      editForm: {},
      form: {
        keyword: '',
        page: 1,
        relations: ['attendance.user']
      },
      total: 1,
      columns: [
        {
          title: '姓名',
          name: 'user',
          align: 'center'
        },
        {
          title: '上班时间',
          name: 'startTime',
          align: 'center'
        },
        {
          title: '下班时间',
          name: 'endTime',
          align: 'center'
        },
        {
          title: '备注',
          name: 'remark',
          align: 'center'
        }
        // {
        //   title: '操作',
        //   align: 'center',
        //   width: 400
        // }
      ],
      list: [],
      moment
    }
  },
  methods: {
    edit(item) {
      this.editForm = item
      this.editOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.attendance.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              this.getAll()
            }
          })
        }
      })
    },
    getAll() {
      this.loading = true
      backend(api.attendance.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data.rows
          this.total = result.data.count
        }
      })
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="less" scoped>
.attendance-index {
  position: relative;
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .table {
    td {
      text-align: center;
      &.red {
        color: #ff4081;
      }
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/attendance/index.vue